import { render, staticRenderFns } from "./JaliscoMapComponent.vue?vue&type=template&id=5bb10a8a"
import script from "./JaliscoMapComponent.vue?vue&type=script&lang=js"
export * from "./JaliscoMapComponent.vue?vue&type=script&lang=js"
import style0 from "./JaliscoMapComponent.vue?vue&type=style&index=0&id=5bb10a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports